import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "react-bootstrap-icons";
import "./userdash.css";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../../redux/userSlice";
import { Button, Modal } from "react-bootstrap";
import LoginModal from "../LoginModal";
import {
  FaUser,
  FaExchangeAlt,
  FaMoneyBillWave,
  FaGift,
  FaDice,
  FaCopy,
  FaCheck,
  FaSignOutAlt,
  FaWallet,
} from "react-icons/fa";

const MENU_ITEMS = [
  { to: "/user-details", label: "My Profile", icon: <FaUser />, color: "#6f8bff" },
  { to: "/transactions", label: "Transactions", icon: <FaExchangeAlt />, color: "#38c0a8" },
  { to: "/withdrawal", label: "Withdrawal", icon: <FaMoneyBillWave />, color: "#f0a13c" },
  { to: "/promos", label: "Promo", icon: <FaGift />, color: "#e263d7" },
  { to: "/user-bet-history", label: "Bet History", icon: <FaDice />, color: "#ff6b6b" },
];

const UserDashboard = ({ onClose = () => {} }) => {
  const dispatch = useDispatch();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [copied, setCopied] = useState(false);
  const user = useSelector((state) => state.user.user);

  const handleProtectedClick = (e) => {
    if (!user) {
      e.preventDefault();
      setShowLogin(true);
      return;
    }

    onClose?.();
  };

  const copyReferral = () => {
    if (!user?.refer?.referralCode) return;
    navigator.clipboard?.writeText(user.refer.referralCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const initial = (user?.userId || user?.username || "G")
    .toString()
    .charAt(0)
    .toUpperCase();

  return (
    <div className="userdash bg-dark text-light">
      <div className="scroll-content left-scroll px-3 pb-3">
        {/* Profile Header */}
        <div className="userdash-profile">
          <div className="userdash-avatar">{initial}</div>
          <div className="userdash-profile-info">
            <div className="userdash-name">{user?.userId || "Guest"}</div>
            <div className="userdash-balance">
              <FaWallet size={12} />
              <span>
                ₹{user?.wallet?.balance?.toLocaleString("en-IN") || "0"}
              </span>
              {user?.wallet?.bonusBalance > 0 && (
                <span className="userdash-bonus">
                  +₹{user.wallet.bonusBalance.toLocaleString("en-IN")} bonus
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Referral Card */}
        {user?.refer?.referralCode && (
          <div className="userdash-referral" onClick={copyReferral} role="button">
            <div>
              <div className="userdash-referral-label">Your Referral Code</div>
              <div className="userdash-referral-code">
                {user.refer.referralCode}
              </div>
            </div>
            <div className="userdash-referral-copy">
              {copied ? <FaCheck className="text-success" /> : <FaCopy />}
              <span>{copied ? "Copied" : "Copy"}</span>
            </div>
          </div>
        )}

        {/* Menu */}
        <div className="userdash-menu">
          {MENU_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={handleProtectedClick}
              className="userdash-item text-decoration-none"
            >
              <span
                className="userdash-item-icon"
                style={{ color: item.color, background: `${item.color}1f` }}
              >
                {item.icon}
              </span>
              <span className="userdash-item-label">{item.label}</span>
              <ChevronRight size={14} className="userdash-item-arrow" />
            </Link>
          ))}
        </div>

        {/* LOGOUT */}
        {user && (
          <button
            className="userdash-logout"
            onClick={() => setShowLogoutConfirm(true)}
          >
            <FaSignOutAlt /> Logout
          </button>
        )}
      </div>

      <Modal
        show={showLogoutConfirm}
        onHide={() => setShowLogoutConfirm(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowLogoutConfirm(false)}
          >
            Cancel
          </Button>

          <Button
            variant="danger"
            onClick={() => {
              setShowLogoutConfirm(false);
              dispatch(logoutUser());
            }}
          >
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
      <LoginModal show={showLogin} handleClose={() => setShowLogin(false)} />
    </div>
  );
};

export default UserDashboard;
